module.exports = __webpack_public_path__ + "static/media/team-dale.be6eca5c.jpg";